import * as React from 'react';
import { TextButton } from 'wix-style-react';
import { biLogger } from '../../../bi';
import { config } from '../../../config';
import { AppMarketLink } from '../../app-market-link';
import ChevronRightSmall from 'wix-ui-icons-common/ChevronRightSmall';
import { composer } from '../../../component-decorators/composer';
import s from './see-more-apps.scss';
import { Path } from '../../../enums/marketplace-enums';
export var SeeMoreApps = composer()
    .withMarketplaceStore()
    .compose(function (_a) {
    var slug = _a.slug, gridType = _a.gridType, marketplaceStore = _a.marketplaceStore, positionBottom = _a.positionBottom;
    var gridTypeIs = gridType;
    var pageType = gridTypeIs === 'COLLECTION' ? Path.COLLECTION : Path.CATEGORY;
    return (React.createElement("div", { className: positionBottom ? s.buttonWrapperBottom : s.buttonWrapper },
        React.createElement(TextButton, { size: "small", weight: "normal", className: s.seeAllCta, dataHook: slug + "-see-all-button", onClick: function () {
                // tslint:disable-next-line: no-floating-promises
                biLogger.categoryClick({
                    category: slug.replace(/-/g, '_'),
                    msid: marketplaceStore.metaSiteId,
                    origin: 'see_all',
                    tag_name: slug.replace(/-/g, '_'),
                    tag_type: 'collection',
                });
                config.goto({
                    path: pageType,
                    slug: slug,
                });
            } },
            React.createElement(AppMarketLink, { to: pageType + "/" + slug, className: s.seeAllCta },
                React.createElement(SeeAllAppsText, null),
                React.createElement(ChevronRightSmall, null)))));
});
var SeeAllAppsText = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t;
    return t('solution.see.all.cta');
});
//# sourceMappingURL=see-more-apps.js.map